import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { HttpService } from '../../../app.common/modules/api/http.service';

import { StateService } from '@uirouter/core';
import { IAuthResponse } from '../../../app.common/modules/account/models';
import { JispPayService } from '../../../app.jisppay/modules/api/jisppay.service';
import { StoreListItem } from '../core';

export enum AuthStatus {
    notAuthenticated,
    storeNotSelected,
    authenticated
}

export enum RedirectPageSaller {
    DELIVERY = 1
}

export interface ICredentials {
    email: string;
    password: string;
}

export interface IUserData {
    isAuth: AuthStatus;
}

export class JispPayAccountService {
    public static $inject = [
        '$rootScope',
        '$localStorage',
        '$httpParamSerializer',
        'http',
        'jispPayService',
        'jispPayServiceUrl',
        '$state'
    ];

    public userData: IUserData = {
        isAuth: AuthStatus.notAuthenticated
    };

    constructor(
        private $rootScope: ng.IRootScopeService,
        private $localStorage: ngStorage.StorageService,
        private $httpParamSerializer: ng.IHttpParamSerializer,
        private http: HttpService,
        private jispPayService: JispPayService,
        private jispPayServiceUrl: string,
        private $state: StateService,
    ) {
        this.setIsAuth();
    }

    public reset() {
        delete this.$localStorage.sellerAuthorizationData;
        this.setIsAuth();
    }

    public async logIn(loginData: ICredentials) {
        const params = `grant_type=sales_assistant_auth&email=${encodeURIComponent(loginData.email)}&password=${encodeURIComponent(loginData.password)}`;
        const header = { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' } };
        const response = await this.http.post<IAuthResponse>(this.getAuthUrl(), params , header);
        if (response.toString() === 'cancel') {
            return null;
        }
        this.$localStorage.sellerAuthorizationData = {
            token: response.access_token,
            type: AuthStatus.storeNotSelected
        };

        return response;
    }

    public async logInByLoginCode(loginCode: string) {
        delete this.$localStorage.sellerAuthorizationData;
        const params = `grant_type=sales_assistant_one_time_login_code_auth&login_code=${loginCode}`;
        const header = { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' } };
        const response = await this.http.post<IAuthResponse>(this.getAuthUrl(), params , header);
        if (response.toString() === 'cancel') {
            return null;
        }
        this.$localStorage.sellerAuthorizationData = {
            token: response.access_token,
            type: AuthStatus.authenticated
        };

        return response;
    }

    public async storeLogIn(storeID: number) {
        const data = {
            grant_type: 'sales_assistant_store_auth',
            store_id: storeID,
            token: this.$localStorage.sellerAuthorizationData.token
        };

        const params = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
        const response = await this.http.post<IAuthResponse>(this.getAuthUrl(), this.$httpParamSerializer(data), params);
        this.$localStorage.sellerAuthorizationData = {
            token: response.access_token,
            type: AuthStatus.authenticated
        };
        this.setIsAuth();

        this.$rootScope.$broadcast('Login');
    }

    public async getUserData() {
        this.setIsAuth();
        return this.userData;
    }

    public getStores() {
        return this.http.get<StoreListItem[]>(this.getStoresUrl(), { params: 'authKey=sellerAuthorizationData' });
    }

    public getStore() {
        return this.http.get<StoreListItem>(this.jispPayService.store());
    }

    public async navigateToDefault() {
        this.setIsAuth();
        this.$state.go(this.getDefaultRoute());
    }

    public async navigateTo(tabId: RedirectPageSaller) {
        this.setIsAuth();
        this.$state.go(this.getDefaultRoute(tabId));
    }

    public isSellerTokenPresents(): boolean {
        const token = this.$localStorage.sellerAuthorizationData;
        return angular.isDefined(token);
    }

    private getDefaultRoute(tabId?: RedirectPageSaller) {
        switch (this.userData.isAuth) {
            case AuthStatus.notAuthenticated:
                return 'account.login';
            case AuthStatus.authenticated:
                if (tabId) {
                    switch (tabId) {
                        case RedirectPageSaller.DELIVERY:
                            return 'jisppay.delivery';
                        default:
                            return 'jisppay.default';
                    }
                } else {
                    return 'jisppay.default';
                }
        }
    }

    private setIsAuth() {
        const authData = this.$localStorage.sellerAuthorizationData;
        this.userData.isAuth = authData ? AuthStatus.authenticated : AuthStatus.notAuthenticated;
    }

    private getAuthUrl() {
        return this.getUrl('auth/token');
    }

    private getUrl(url: string) {
        return this.jispPayServiceUrl + url;
    }

    private getStoresUrl() {
        return this.getUrl('stores');
    }
}

angular.module('naut').service('jispPayAccountService', JispPayAccountService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/account/jispPayAccount.service.ts